// =========================
// CREATE EVENT VIEW
// =========================
import App from './../../App';
import { html, render } from 'lit-html';
import { gotoRoute } from './../../Router';
import Auth from './../../Auth';
import Utils from './../../Utils';

// This is the CreateEventView class that handles the creation of events
// It initializes the view, handles form submission, and renders the event creation form.
class CreateEventView {
  constructor() {
    this.user = Auth.currentUser;
  }

  // This method is called to initialize the view
  async init() {
    document.title = 'PopIn – Create Event';
    this.render();
    Utils.pageIntroAnim();
  }

  // This method handles the form submission for creating an event
  async handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    try {
      const res = await fetch(`${App.apiBase}/event`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: formData,
      });

      if (!res.ok) {
        const errorData = await res.json();
        console.error('Server responded with:', errorData);
        throw new Error('Failed to create event');
      }

      const newEvent = await res.json();
      gotoRoute(`/event?id=${newEvent._id}`);
    } catch (err) {
      console.error('Error creating event:', err);
      alert('There was a problem creating the event. Please try again.');
    }
  }

  render() {
    const template = html`
      <div class="layout create-event">
        <popin-side-nav></popin-side-nav>
        <div class="main-area">
          <popin-top-bar .user=${this.user}></popin-top-bar>
          <div class="main-content">
            <h1>Create Event</h1>
            <form @submit=${this.handleSubmit} class="event-form">
              <sl-input name="title" label="Event Title" required></sl-input>
              <sl-textarea
                name="description"
                label="Description"
                rows="4"
                required
              ></sl-textarea>
              <sl-input name="location" label="Location" required></sl-input>
              <sl-input
                name="dateTime"
                type="datetime-local"
                label="Date & Time"
                required
              ></sl-input>
              <sl-select name="category" label="Category" required>
                <sl-option value="social">Social</sl-option>
                <sl-option value="educational">Educational</sl-option>
                <sl-option value="networking">Networking</sl-option>
                <sl-option value="entertainment">Entertainment</sl-option>
              </sl-select>
              <sl-select name="visibility" label="Visibility" required>
                <sl-option value="public">Public</sl-option>
                <sl-option value="private">Private</sl-option>
              </sl-select>
              <label class="file-upload">
                <span>Event Image</span>
                <input type="file" name="eventImage" accept="image/*" />
              </label>

              <sl-button type="submit" variant="neutral"
                >Create Event</sl-button
              >
            </form>
          </div>
        </div>
      </div>
    `;
    render(template, App.rootEl);
  }
}

export default new CreateEventView();
